import OnboardingTutorialMainWrapper from "./components/OnboardingTutorialMainWrapper/OnboardingTutorialMainWrapper";
import { OnboardingTutorialStepForwardButton } from "./components/OnboardingTutorialStepForwardButton";
import { useGTMEvent } from "../../GoogleTagManager/googleTagManagerHooks";
import { useCallback } from "react";
import { ONBOARDING_TUTORIAL_IMAGES } from "./onboardingTutorialConstants";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext.js";

export const OnboardingTutorialLots = () => {
    const {getLangPath} = useLangContext();
    const {pushGtmEvent} = useGTMEvent({module: 'OnboardingTutorialLots'});

    const handleStepForwardClick = useCallback(() => {
        pushGtmEvent({event: 'onboarding_click', button: 'Next'})
    }, [pushGtmEvent]);

    return <OnboardingTutorialMainWrapper backgroundImg={ONBOARDING_TUTORIAL_IMAGES.LOTS_BG}
                                          contentContainerMaxWidth="300px">
        <p dangerouslySetInnerHTML={{__html: getLangPath('onboarding.lots_description')}}/>
        <OnboardingTutorialStepForwardButton onClick={handleStepForwardClick}/>
    </OnboardingTutorialMainWrapper>
}
